<template>
  <div>
    <div v-if="!selected">
      <div
        style="
          margin-left: 4rem;
          margin-top: 3rem;
          display: flex;
          flex-wrap: wrap;
        "
      >
        <!-- <div class="col-6">
          <v-select
            outline
            v-model="campaign_type"
            :items="campaign_types"
            label="Email Campaign Type"
            item-value="campaign_type"
            item-text="name"
          ></v-select>
        </div> -->
        <div align="left" class="col-6">
          <button
            @click="onSelect"
            class="btn btn-def"
            style="min-width: 30rem"
          >
            Create New Campaign
          </button>
        </div>
      </div>
      <div id="header">All campaigns</div>
      <table>
        <tr>
          <!-- <th>Campaign name</th> -->
          <th>Created By</th>
          <th>Email Subject</th>
          <th>End Time</th>
          <th>Audience</th>
          <th>Engagement</th>
          <th>Action</th>
        </tr>
        <tr v-for="campaign in campaigns" :key="campaign.campaign_id">
          <!-- <td>{{ campaign_type_name[campaign.campaign_type] }}</td> -->
          <td>{{ campaign.created_by }}</td>
          <td>{{ campaign.email_subject }}</td>
          <td>{{ getDate(campaign.end_date) }}</td>
          <td>{{ campaign.send_count }}</td>
          <td>{{ campaign.click_count }}</td>
          <td>
            <v-icon
              @click="onDeleteLog(campaign.campaign_id)"
              class="icon-class-reject"
              >mdi-delete</v-icon
            >
          </td>
        </tr>
      </table>
    </div>
    <div v-if="selected">
      <CampaignDetailsVue
        :campaign_type="campaign_type"
        :campaign_type_name="campaign_type_name"
        @close-details="removeSelect"
      />
    </div>
    <!-- <div>
      <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="snackbar">
        <div style="text-align: center; width: 100%">
          <span style="padding-right: 1rem"
            ><v-icon color="#fff">{{ snackIcon }}</v-icon></span
          >{{ snackMessage }}
        </div>
      </v-snackbar>
    </div> -->
    <div v-if="openPopup">
      <popup-box
        :persist=true
        v-on:box-closed="openPopup = false"
        v-bind="popupBoxProps"
        v-bind:key="check"
      ></popup-box>
    </div>
  </div>
</template>

<script>
import PopupBox from "../../global-components/pop-up-box";
import CampaignDetailsVue from "./campaign-details.vue";
import { GET_EMAIL_CAMPAIGN } from "../../../Api/admin_api";
import { DELETE_EMAIL_CAMPAIGN } from "../../../Api/admin_api";
import { required } from "vuelidate/lib/validators";
export default {
  name: "all-campaigns",
  // validations: {
  //   campaign_type: {
  //     required
  //   }
  // },
  data() {
    return {
      selected: false,
      campaign_type: "UNVERIFIED_VERIF",
      campaign_types: [],
      // bgColor: "",
      // timeOut: 1000,
      // snackbar: false,
      // snackIcon: "",
      // snackMessage: "",
      campaigns: [],
      campaign_type_name: {
        UNVERIFIED_VERIF: "Unverified Users Verification",
        NUDGE_CAND: "Nudge Inactive Candidate",
        PROFILE_COMP: "Profile Completion",
        JOB_INV: "Job Posting Invitation",
      },
      openPopup: false,
      popupBoxProps: {
        open: false,
        message: "",
        title: "",
        resendMail: false,
      },
      check: 0,
    };
  },
  methods: {
    onDeleteLog(campaign_id) {
      const self = this;
      let params_log = {
        campaign_id: campaign_id,
      };
      DELETE_EMAIL_CAMPAIGN(params_log)
        .then(function (response) {
          // self.snackbar = true;
          // self.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
          // self.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
          // self.snackMessage = response.message ? response.message : self.$constants.ERROR_MESSAGES.UPDATED;
          self.openPopup = true;
          let msg = response.message ? response.message : self.$constants.ERROR_MESSAGES.UPDATED;
          self.popupBoxProps = {
            open: true,
            message: msg,
            title: "SUCCESS",
            resendMail: false,
          };
          self.getEmailCampaigns();
          self.check++;
        })
        .catch(function (error) {
          // self.snackbar = true;
          // self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          // self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          // self.snackMessage = error.response.data.title + ". " + error.response.data.message;
          self.openPopup = true;
          let msg = error.response.data.title + ". " + error.response.data.message;
          self.popupBoxProps = {
            open: true,
            message: msg,
            title: "FAILED",
            resendMail: false,
          };
          self.check++;
        });
    },
    getDate(timestamp) {
      let unix_timestamp = timestamp;
      // Create a new JavaScript Date object based on the timestamp
      // multiplied by 1000 so that the argument is in milliseconds, not seconds. Backend gives in seconds
      let date = new Date(unix_timestamp * 1000);
      // Hours part from the timestamp
      let hours = date.getHours();
      // Minutes part from the timestamp
      let minutes = "0" + date.getMinutes();
      // Seconds part from the timestamp
      let seconds = "0" + date.getSeconds();
      // Will display time in 10:30:23 format
      let formattedTime =
        hours + ":" + minutes.substr(-2) + ":" + seconds.substr(-2);
      // console.log(formattedTime);
      return (
        formattedTime +
        " -- " +
        date.getDate() +
        "/" +
        (date.getMonth() + 1) +
        "/" +
        date.getFullYear()
      );
    },
    onSelect() {
      const self = this;
      // if (this.campaign_type === null) {
      //   self.snackbar = true;
      //   self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
      //   self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
      //   self.snackMessage = "Select Campaign Type";
      //   return;
      // }
      this.selected = true;
    },
    removeSelect() {
      this.selected = false;
      this.getEmailCampaigns();
    },
    opendropdown() {
      this.$refs.menu.open();
    },
    // campaignTypeError() {
    //   const errors = [];
    //   if (!this.$v.campaign_type.$dirty) return errors;
    //   !this.$v.campaign_type.required &&
    //     errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
    //   return errors;
    // },
    getEmailCampaignTypes() {
      let params = {
        templates: true,
      };
      const self = this;
      GET_EMAIL_CAMPAIGN(params)
        .then(function (data) {
          self.campaign_types = data.campaigns;
          // console.log(self.campaign_types);
        })
        .catch(function (err) {});
    },
    getEmailCampaigns() {
      let params = {
        templates: false,
      };
      const self = this;
      GET_EMAIL_CAMPAIGN(params)
        .then(function (data) {
          self.campaigns = data.campaigns;
          // console.log(self.campaigns);
        })
        .catch(function (err) {});
    },
  },
  components: {
    CampaignDetailsVue,
    PopupBox,
  },
  mounted() {
    this.getEmailCampaignTypes();
    this.getEmailCampaigns();
  },
};
</script>

<style scoped>
#header {
  margin-top: 3rem;
  margin-left: 4rem;
  height: 3.3rem;
  font-size: 2.6rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.27;
  letter-spacing: normal;
  text-align: left;
}
table {
  margin: 5rem 4rem;
  width: 90%;
}
th {
  background-color: #f2f3f8;
}
td,
th {
  /* word-wrap: break-word; */
  /* max-width: 30rem; */
  border-bottom: 0.1rem solid #dedede;
  text-align: left;
  padding: 8px;
}
</style>